import React from 'react';
import Markdown from 'react-markdown';
import SproutsAiBadgeV2 from '../SproutsAIBadgeV2';

interface Props {
  loading?: boolean;
  value: string;
}

const AiQuestionContainer: React.FC<Props> = ({ value }) => {
  return (
    <div className="ai-question-tooltip-wrapper">
      <div className="ai-question-heading">
        <p className="ai-question-title">Generated AI Signal</p>
        <SproutsAiBadgeV2 type="secondary" size="default" />
      </div>

      <div className="ai-question-container">
        <Markdown>{value}</Markdown>
      </div>
    </div>
  );
};

export default AiQuestionContainer;
